import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import 'react-tabs/style/react-tabs.css'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { Grid } from '../Grid'
import DesktopDetailVerticalTab from './DesktopDetailTabs'
import ResponsiveDetailTabs from './MobileDetailTabs'
import classes from './detailVerticalTab.module.scss'
import { TabsProps } from './types'

const DetailVerticalTab: React.FC<PropsWithChildren<TabsProps>> = ({ data,strokeColor }) => {
  const isMobile = useMediaQuery('(max-width: 768px')
  const tabClasses = [classes.detailVerticalTabsContainer]
 
  switch (strokeColor) {
  case 'blue':
    tabClasses.push(classes.detailBlue)
    break
  case 'yellow':
    tabClasses.push(classes.detailYellow)
    break
  case 'orange':
    tabClasses.push(classes.detailOrange)
    break
  case 'purple':
    tabClasses.push(classes.detailPurple)
    break
  case 'green':
    tabClasses.push(classes.detailGreen)
    break
  case 'red':
    tabClasses.push(classes.detailRed)
    break
  default:
    break
  }

  return (
    <Grid container className={classNames(tabClasses)}>
      {!isMobile ? 
        <DesktopDetailVerticalTab data={data} strokeColor={strokeColor}/> :
        <ResponsiveDetailTabs data={data} strokeColor={strokeColor}/>  
      }
    </Grid>
  )
}


export default DetailVerticalTab